import NewsletterDominoView from 'pages/private/Newsletters/Domino/NewsletterDomino';

const NewsletterDomino = () => {
  return <NewsletterDominoView />;
};

export default NewsletterDomino;
